import React from 'react';

interface State {
  hasError: boolean;
}

/**
 * Isolates the support widget from the app shell. If anything inside the chat
 * throws, the boundary swallows it and renders nothing — the rest of the site
 * keeps working (US1: a chat failure must never break the page).
 */
class SupportChatErrorBoundary extends React.Component<
  { children: React.ReactNode },
  State
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown): void {
    // Soft-log only; never surface to the user.
    // eslint-disable-next-line no-console
    console.warn('SupportChat disabled after error:', error);
  }

  render(): React.ReactNode {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}

export default SupportChatErrorBoundary;
